import axios from "@/api/config";
const teahcer = {
  getTeacherList(data) {
    return axios.get(`${process.env.BASE_URL}/teacher/getTeacherList`, {
      params: data
    });
  },
  getTeacherTree(data) {
    return axios.get(`${process.env.BASE_URL}/teacher/getTeacherTree`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/teacher/pageList`, data);
  },
  addTeacher(data) {
    return axios.post(`${process.env.BASE_URL}/teacher/addTeacher`, data);
  },
  deleteTeacher(data) {
    return axios.delete(`${process.env.BASE_URL}/teacher/deleteTeacher`, {
      data: data
    });
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/teacher/active`, data);
  },
  updateTeacher(data) {
    return axios.put(`${process.env.BASE_URL}/teacher/updateTeacher`, data);
  },
  teacherCalendarInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/classInfo/teacherCalendarInfo`,
      data
    );
  }
};
export default teahcer;



// WEBPACK FOOTER //
// ./src/api/teacher.js